import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PermissionWrapperComponent } from './components/permission-wrapper.component';
import { PermisionsDirective } from './directives/permissions.directive';


@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
        MatIconModule
    ],
    exports: [
        PermisionsDirective
    ],
    declarations: [
        PermisionsDirective,
        PermissionWrapperComponent
    ],
    providers: [],
})
export class PermissionsModule { }
